export enum CpwCustomPermissions {
    OperationsCanReceive = 'Operations:CanReceive',
    OperationsCanPutAway = 'Operations:CanPutAway',
    OperationsCanPick = 'Operations:CanPick',
    OperationsCanPack = 'Operations:CanPack',
    OperationsCanReplenish = 'Operations:CanReplenish',
    OperationsCanCycleCount = 'Operations:CanCycleCount',
    OperationsCanViewShipments = 'Operations:CanViewShipments',
    OperationsCanViewExceptions = 'Operations:CanViewExceptions',
    OperationsCanManageExceptions = 'Operations:CanManageExceptions',
    OperationsExceptionManagerApproval = 'Operations:ExceptionManagerApproval',
    ManagementCanViewManageOptions = 'Management:CanViewManageOptions',
    ManagementCanViewWarehouseOptions = 'Management:CanViewWarehouseOptions',
    ManagementCanViewReportingOptions = 'Management:CanViewReportingOptions',
    ManagementCanManageWarehouseLocationsAndInventory = 'Management:CanManageWarehouseLocationsAndInventory',
    ManagementCanManageHandlingUnits = 'Management:CanManageHandlingUnits',
    ManagementCanSetWillCall = 'Management:CanSetWillCall',
    ManagementCanSetHotShot = 'Management:CanSetHotShot',

    // Reporting permissions
    ReportingCanViewAllReports = 'Reporting:CanViewAllReports',
    ReportingCanViewDailyOperationsSummary = 'Reporting:CanViewDailyOperationsSummary',
    ReportingCanViewInventoryHealth = 'Reporting:CanViewInventoryHealth',
    ReportingCanViewWarehousePerformance = 'Reporting:CanViewWarehousePerformance',
    ReportingCanViewExceptionsOverview = 'Reporting:CanViewExceptionsOverview',
    ReportingCanViewExceptionTrends = 'Reporting:CanViewExceptionTrends',
    ReportingCanViewRequisitionPipeline = 'Reporting:CanViewRequisitionPipeline',
    ReportingCanViewPurchaseOrders = 'Reporting:CanViewPurchaseOrders',
    ReportingCanViewASNs = 'Reporting:CanViewASNs',
    ReportingCanViewReceivingProductivity = 'Reporting:CanViewReceivingProductivity',
    ReportingCanViewWorkOrder = 'Reporting:CanViewWorkOrder',
    ReportingCanViewPickingPerformance = 'Reporting:CanViewPickingPerformance',
    ReportingCanViewShipments = 'Reporting:CanViewShipments',
    ReportingCanViewInventorySnapshot = 'Reporting:CanViewInventorySnapshot',
    ReportingCanViewInventoryAging = 'Reporting:CanViewInventoryAging',
    ReportingCanViewItemMasterCatalog = 'Reporting:CanViewItemMasterCatalog',
    ReportingCanViewTransactionRegister = 'Reporting:CanViewTransactionRegister',
    ReportingCanViewWarehouseLocations = 'Reporting:CanViewWarehouseLocations',
    ReportingCanViewEquipmentTracking = 'Reporting:CanViewEquipmentTracking',
    ReportingCanViewContainerTracking = 'Reporting:CanViewContainerTracking',
    ReportingCanViewCycleCounts = 'Reporting:CanViewCycleCounts',
    ReportingCanViewReplenishments = 'Reporting:CanViewReplenishments',
    ReportingCanViewWorkforce = 'Reporting:CanViewWorkforce',
    ReportingCanViewSupplierScorecarding = 'Reporting:CanViewSupplierScorecarding',
}
